import { Box, Flex } from "@mantine/core";
import { Outlet, useLocation } from "react-router-dom";
import { useSessionStore } from "stores/userSessionStore";

interface MainAdminPageProps {
  title?: string;
}
const MainAdminPage: React.FC = () => {
  const location = useLocation();
  const selectedSystem = useSessionStore((s) => s.selectedSystem);
  return (
    <Flex
      mih={600} // minimum height if needed
      style={{ minWidth: 1200 }} // prevent collapsing below 800px
    >
      {/* Main Content */}
      <Box
        style={{
          minWidth: 1200,
          width: "100%",
        }}
        p="md"
      >
        <Outlet />
      </Box>
    </Flex>
  );
};

export default MainAdminPage;
